import { ExploreItemProps } from "../screens/ExplorePanel/interfaces/ExploreSection";

const FAVORITES_STORAGE_KEY = "explorePanelFavorites";

/**
 * Save favorites to localStorage
 */
export const saveFavoritesToStorage = (favorites: ExploreItemProps[], userId: string): void => {
  try {
    localStorage.setItem(FAVORITES_STORAGE_KEY + userId.toString(), JSON.stringify(favorites));
  } catch (error) {
    //Error saving favorites to localStorage
  }
};

/**
 * Get favorites from localStorage
 */
export const getFavoritesFromStorage = (userId: string): ExploreItemProps[] | null => {
  try {
    const favoritesString = localStorage.getItem(FAVORITES_STORAGE_KEY + userId.toString());
    if (favoritesString) {
      return JSON.parse(favoritesString);
    }
    return null;
  } catch (error) {
    //Error getting favorites from localStorage
    return null;
  }
};

/**
 * Clear all favorites from localStorage
 */
export const clearFavoritesFromStorage = (userId: string): void => {
  try {
    localStorage.removeItem(FAVORITES_STORAGE_KEY + userId.toString());
  } catch (error) {
    //Error clearing favorites from localStorage
  }
};

/**
 * Check if an item is in favorites
 */
export const isItemInFavorites = (itemId: string, userId: string): boolean => {
  const favorites = getFavoritesFromStorage(userId);
  return favorites ? favorites.some((fav) => fav.id === itemId) : false;
};
